module.exports = __webpack_public_path__ + "img/W-G43.0f46486f.jpg";